const STEPS = ["welcome", "account_type", "brand_setup", "listing_teaser", "ready"] as const

export default function ProgressIndicator({ currentStep }: { currentStep: string }) {
  const currentIndex = STEPS.indexOf(currentStep as (typeof STEPS)[number])
  const progress = currentIndex >= 0 ? ((currentIndex + 1) / STEPS.length) * 100 : 0

  return (
    <div className="fixed inset-x-0 top-0 z-50 h-1 bg-stone/30">
      <div
        className="h-full bg-red transition-all duration-700 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
